<div [class.commercial]="isCommercial" [class.luxury]="isLuxury" [class.residential]="isResidential">
  <div [jsonSchema]="productSchema"></div>
  <section class="hero-banner" [ngStyle]="isScreenSizeGreaterThanTablet ? showBannerStyle: ''">
    <div class="wrapper" [ngStyle]="!isScreenSizeGreaterThanTablet ? showBannerStyle: ''">
      <div class="inner-content">
        <div class="title text-center">
          <h2 id="landingPage-label-odometer" *ngIf="isResidential">
            {{ bannerTitleFirstPart }}
            <span *ifPlatform="'browser'" id="odometer" class="odometer" [innerText]="totalListings"></span>
            <span *ifPlatform="'server'" class="odometer">000,000</span> {{ bannerTitleSecondPart }}
          </h2>
          <h2 translate="landing-page-commercial.your-locally-connected-commercial-experts" *ngIf="isCommercial"></h2>
          <h2 translate="landing-page-luxury.selling-luxury-in-over-100-countries" *ngIf="isLuxury"></h2>
        </div>
        <div class="search-bar-wrapper">
          <div class="search-input-and-button">
            <app-search-bar #appSearchBar
              [rightPositionedIcon]="true"
              [placeholder]="
                screenSize < SCREEN_SIZE.DESKTOP_UP
                  ? ('landing-page-residential.neighbourhoods-city-or-listing-id' | translate)
                  : ('landing-page-residential.search-any-neighbourhoods-city-or-listing-id' | translate)
              "
              [updatePlaceholder]="false"
              [searchIcon]="searchIcon"
            ></app-search-bar>
            <button *ngIf="isResidential" id="lets-go-button" routerLink="/find-real-estate" (click)="searchBar.onSubmit()" class="btn btn-primary btn-lets-go">
              <span translate="landing-page.search-button"></span>
            </button>
          </div>
          <a routerLink="/find-real-estate" (click)="centerMapAtUserLocation()">
            <span class="sub-title is-flex has-flex-align-center has-flex-content-center">
              <span *ngIf="!isResidential" style="margin-right: 10px">
                <img src="{{ '/assets/landing_page/target@1x.svg' | staticp }}" [alt]="'aria.target' | translate" />
              </span>
              <span class="search-near-me" translate="landing-page-residential.search-listings-near-me"></span>
              <i *ngIf="screenSize === SCREEN_SIZE.MOBILE_ONLY" class="material-icons">chevron_right</i>
            </span>
          </a>
        </div>
      </div>
    </div>
    <h1 class="title is-flex text-center">{{ h1Text }}</h1>
  </section>

  <!---<section class="second-section personas">
    <div class="section-wrapper" *ngIf="isResidential">
      <h2 class="title is-flex text-center" translate="landing-page-residential.personas.title">
        Search by Lifestyle & Neighbourhood
      </h2>
      <div class="is-flex is-flex-column">
        <div class="is-flex has-flex-content-space-between has-flex-wrap persona-wrapper">
          <a id="{{persona.name}}" class="persona has-pos-rel" *ngFor="let persona of personas" [routerLink]="persona.url">
            <img src="{{persona.image | staticp }}" alt="{{persona.name | translate}}">
            <span class="btn btn-persona has-pos-abs" [translate]="persona.name"></span>
          </a>
        </div>
      </div>
    </div>
  </section>-->

  <section id="appLandingPage-section-newestListings" class="second-section newest-listings">
    <app-item-swiper
      *ngIf="!isLuxury"
      [items]="suggestedListings"
      [hasFinishedLoadingItems]="suggestedListings.length"
      [isLandingPageListing]="true"
    ></app-item-swiper>
    <div *ngIf="isLuxury">
      <div *ngFor="let listing of suggestedListings; let odd = odd; let even = even" class="luxury-listing">
        <ng-container *ngIf="screenSize <= SCREEN_SIZE.MOBILE_ONLY">
          <div class="listing-info text-center">
            <div
              class="type"
              [translate]="listing.isLeaseOrRental ? 'landing-page-luxury.for-rent' : 'landing-page-luxury.for-sale'"
            ></div>
            <div class="full-address">{{ listing.address }}</div>
            <div class="community">
              <app-listing-address
                [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"
              ></app-listing-address>
            </div>
          </div>
          <app-listing-card
            [listing]="listing"
            [isListingDetails]="true"
            [isSelectedCard]="true"
            [isLandingPageListing]="true"
          ></app-listing-card>
          <div class="button-wrapper">
            <button class="btn btn-luxury full-width" [routerLink]="['/' + listing.detailUrl]">
              <span class="full-width" translate="landing-page-luxury.view-listing-details"></span>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="screenSize > SCREEN_SIZE.MOBILE_ONLY">
          <div class="courtesy" *ngIf="listing.isLuxury">{{ listing | courtesyMessage }}</div>
          <app-listing-summary-desktop-content
            [listing]="listing"
            [forceLuxuryStyle]="true"
            [class.odd]="odd"
            [class.even]="even"
            [isLandingPageListing]="true"
            [showVideoAndVirtualTour]="false"
            [showContactAgent]="false"
            [showScheduleViewing]="false"
            [showViewListingDetails]="true"
          ></app-listing-summary-desktop-content>
        </ng-container>
      </div>
      <div *ngIf="!suggestedListings || suggestedListings.length === 0" class="luxury-listing">
        <p class="text-center" translate="panel-message.getting-listings"></p>
      </div>
    </div>
    <div *ngIf="isCommercial">
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width">
          <span class="top-margin" translate="commercial-landing-page-description.commercial-confidence-header"></span>
        </h3>
        <div class="line hide-on-desktop-up"></div>
        <div>
          <p class="text" translate="commercial-landing-page-description.commercial-confidence-body"></p>
          <p class="text red-bold" translate="commercial-landing-page-description.commercial-confidence-red"></p>
        </div>
      </div>
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width">
          <span translate="commercial-landing-page-description.all-inclusive-header"></span>
        </h3>
        <div class="line hide-on-desktop-up"></div>
        <p class="text" translate="commercial-landing-page-description.all-inclusive-body"></p>
      </div>
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width"><span translate="commercial-landing-page-description.reach-header"></span></h3>
        <div class="line hide-on-desktop-up"></div>
        <p class="text" translate="commercial-landing-page-description.reach-body"></p>
      </div>
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width"><span translate="commercial-landing-page-description.leader-header"></span></h3>
        <div class="line hide-on-desktop-up"></div>
        <p class="text" translate="commercial-landing-page-description.leader-body"></p>
      </div>
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width"><span translate="commercial-landing-page-description.spec-header"></span></h3>
        <div class="line hide-on-desktop-up"></div>
        <p class="text" translate="commercial-landing-page-description.spec-body"></p>
      </div>
      <div class="line line-desktop hide-on-desktop-down"></div>
      <div class="section">
        <h3 class="title-fixed-width"><span translate="commercial-landing-page-description.join-header"></span></h3>
        <div class="line hide-on-desktop-up"></div>
        <p class="text" translate="commercial-landing-page-description.join-body"></p>
      </div>
    </div>
  </section>

  <section class="hero-video" *ngIf="isResidential" [ngStyle]="showVideoStyle">
    <div class="video-container">
      <iframe [src]="videoUrl"></iframe>
      <div class="video-label">
        <h2 class="video-title" translate="landing-page-residential.agents-help-thousands"></h2>
        <a routerLink="/find-real-estate" (click)="centerMapAtUserLocation()">
          <span class="video-paragraph sub-title is-flex has-flex-align-center has-flex-content-center">
            <span>
              {{ 'landing-page-residential.explore-market' | translate }} <i class="material-icons">chevron_right</i>
            </span>
          </span>
        </a>
      </div>
    </div>
  </section>

  <section
    id="appLandingPage-section-blogPosts"
    class="blog-posts is-flex is-flex-column"
    *ngIf="isResidential"
  >
    <app-blog-posts class="blog-post-content" [sourcePage]=BlogPostSourcePage.HomePage ></app-blog-posts>
  </section>

  <section class="td-ad" *ngIf="tdAd" [innerHTML]="tdAd | safeHtml"></section>

  <app-notification-popup-modal
    *ngIf="showUnsubscribedModal"
    (onClose)="showUnsubscribedModal = false"
    [title]="'unsubscribed.title' | translate"
    [messageText]="'unsubscribed.text' | translate"
  >
  </app-notification-popup-modal>
</div>
